module.exports = __webpack_public_path__ + "static/media/homeSearchIcon.ea5233a6.svg";